import {action} from "mobx";
import appStore from "./appStore";
import optionService from "../services/optionService";

class optionsStore {
    @action getOptionsByGroupName = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await optionService.getOptionsByGroupName(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };

    @action getOptions = async params => {
        await appStore.setLoading(true);
        const resultOfRequest = await optionService.getOptions(params);
        await appStore.setLoading(false);
        if (resultOfRequest.status !== 200) {
            appStore.openErrorModal({content: resultOfRequest.data.message});
            return false;
        }
        return resultOfRequest.data;
    };
}

export default new optionsStore();
